import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  token: null,
  userInfo: null,
  roles: null,
  isLogin: false,
  dataTables: {},
  memoList: [], // 备忘列表
  ems: null // 环信服务
}

const mutations = {
  SET_TOKEN (state, token) {
    state.token = token
  },
  REMOVE_TOKEN (state) {
    state.token = null
  },
  SET_USERINFO (state, userInfo) {
    state.userInfo = userInfo
  },
  SET_LOGIN (state, isLogin) {
    state.isLogin = isLogin;
  },

  /**
   * 保存 数据表格
   * @param state VUEX mutations 的第一个默认参数
   * @param map {key, dt} 建议使用请求路径作为key， 如果请求路径被多个地方用到，那么加上页面路由前缀; dt DataTable的实例
   */
  SET_DATA_TABLE (state, map) {
    state.dataTables[map.key] = map.dt;
  },

  /**
   * 保存 系统备忘
   * @param state VUEX mutations 的第一个默认参数
   * @param list
   * @constructor
   */
  SET_SYSTEM_MEMO_LIST (state, list) {
    state.memoList = list;
  },

  /**
   * 保存环信服务
   * @param state
   * @param ems
   * @constructor
   */
  SET_EMS (state, ems) {
    state.ems = ems;
  }
}

export default new Vuex.Store({
  state: state,
  mutations: mutations
})



// WEBPACK FOOTER //
// ./src/store.js